export default "__VITE_ASSET__itCi_vwp__"